<script setup>
defineProps({
    type: {
        type: String,
        default: 'submit',
    },

    success: {
        type: Boolean,
        default: false,
    },
})
</script>

<template>
    <button
        :type="type"
        :class="[
            'focus-visible:outline-sky-500 block w-full cursor-pointer rounded-xl px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2',
            success ? 'bg-green-500' : 'bg-sky-500 hover:bg-sky-500/80',
        ]"
    >
        <transition
            mode="out-in"
            leave-active-class="transition ease-in duration-300"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
            enter-active-class="transition ease-out duration-300"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
        >
            <span
                v-if="success"
                key="success"
            >
                Úspěšně odesláno
            </span>
            <span
                v-else
                key="default"
            >
                <slot />
            </span>
        </transition>
    </button>
</template>
